<p-dialog
  *ngIf="displayedNotification"
  header="Fehlerdetails"
  [modal]="true"
  [(visible)]="display"
  [style]="{ width: '60%' }"
  appendTo="body"
>
  <div class="flex pb-3 gap-5 monospace">
    <div *ngIf="displayedNotification.data.timeStmp">
      Zeitstempel: {{ displayedNotification.data.timeStmp | date: 'medium' }}
    </div>
    <div *ngIf="displayedNotification.data.errCode">Error Code: {{ displayedNotification.data.errCode }}</div>
  </div>

  <span class="inline-block w-full">
    <label>Fehlermeldung:</label>
    <textarea
      pInputTextarea
      id="message"
      rows="3"
      [value]="displayedNotification.summary"
      readonly
      class="notifications__textarea"
    ></textarea>
  </span>

  <span *ngIf="displayedNotification.detail" class="inline-block mt-3 w-full">
    <label>Output:</label>
    <textarea
      pInputTextarea
      id="output"
      rows="5"
      [value]="displayedNotification.detail"
      readonly
      class="notifications__textarea"
    ></textarea>
  </span>

  <span *ngIf="displayedNotification.data.stacktrace" class="inline-block mt-3 w-full">
    <label>Stacktrace:</label>
    <textarea
      pInputTextarea
      id="stacktrace"
      rows="30"
      [value]="displayedNotification.data.stacktrace"
      readonly
      class="notifications__textarea"
      style="white-space: pre"
    ></textarea>
  </span>
</p-dialog>

<p-toast class="notifications__toast--on-top">
  <ng-template let-notification pTemplate="message">
    <div class="notifications__toast__msg-center">
      <div class="notifications__toast__type-btn"><i [class]="notification.data.icon"></i></div>
      <div class="notifications__toast__message">
        <b>{{ notification.summary }}</b>
      </div>
    </div>
    <button
      *ngIf="notification.detail || notification.data.stacktrace"
      type="button"
      class="p-toast-icon-close p-link"
      (click)="showDetails(notification)"
    >
      <span class="p-toast-close-icon pi pi-info"></span>
    </button>
  </ng-template>
</p-toast>
